import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { EinstiegResponse, Feature, Vermittlernummer } from '@ps20/bff-models';
import { IAppState } from '@ps20-frontend/apps/toolbar-store';

export function accountManagerReducer(
  sectionState: Vermittlernummer = null,
  action: AnyAction,
  state: IAppState,
): Vermittlernummer {
  if (action.type === GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL) {
    const actionPayload: EinstiegResponse = action.payload;
    if (
      state.transientState.featureToggles[Feature.VTNR_AMISNOW] &&
      state.transientState.isSdwSession &&
      (!sectionState || sectionState === actionPayload.vertreter.defaultVermittlernummer)
    ) {
      return actionPayload.vertreter.defaultVermittlernummer;
    }
  }
  return sectionState;
}
